import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faList, faListUl, faChartLine } from '@fortawesome/free-solid-svg-icons';
import './BigData.css';
import WaterChart from './WaterChart';

function WaterWheelChart() {
  const [selectedCategory, setSelectedCategory] = useState('');

  return (
    <div>
      <div className="main-content min-h-[500px] flex flex-col justify-center">
        <div className='flex justify-center text-2xl text-yellow-200 mb-16'>BMC Water Stock</div>
        
        <div className='flex justify-center text-lg text-yellow-200 mb-16'>
        <select
            value={selectedCategory}
            onChange={e => setSelectedCategory(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded-md mr-8"
          >
            <option value="">Select Category</option>
            <option value="stockMarket">Stock Market Analysis</option>
            <option value="cryptoTrading">Cryptocurrency Trading</option>
            <option value="commodityMarkets">Commodity Markets</option>
            <option value="forexTrading">Forex Trading</option>
            <option value="realEstate">Real Estate Market Trends</option>
            <option value="governmentBonds">Government Bonds and Treasury Bills</option>
            <option value="interestRates">Interest Rate Fluctuations</option>
            <option value="energyTrends">Energy Consumption & Pricing Trends</option>
            <option value="salesRevenue">Sales and Revenue Analysis</option>
            <option value="economicIndicators">Inflation and Economic Indicators</option>
          </select>

        </div>

        <div className="min-h-[500px]">
          {WaterChart ()}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>            
    </div>
  );
};

export default WaterWheelChart;
